<template>
  <div id="popup-container">
    <v-toolbar dark color="primary" class="Rectangle-6">
      <v-toolbar-title class="heading-title">
        Edit: {{ course.name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout class="layout-container">
        <v-flex xs12>
          <v-card flat>
            <v-form ref="form">
              <v-text-field
                class="input-fld"
                :error-messages="messages.name"
                v-model="course.name"
                label="Course Name"
                type="text"
                filled
                :disabled="
                  is_editable == 1 &&
                  $store.getters.user.email != 'defaultuser@improve.online'
                "
              >
                <!-- <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span>Enter course name</span>
                  </v-tooltip>
                </template> -->
              </v-text-field>
              <!-- <v-textarea
                v-model="course.description"
                label="Description"
                hint="Enter a description for this course"
                filled
              >
                <template slot="append-outer">
                  <v-tooltip left>
                   <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                   </template>
                   <span>Enter a description for this course</span>
                  </v-tooltip>
                </template>
              </v-textarea> -->
              <v-layout class="mb-5 d-block">
                <ckeditor
                  :editor="editor"
                  class="ckeditor"
                  v-model="course.description"
                  tag-name="textarea"
                  :config="editorConfig"
                >
                </ckeditor>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <!--<v-text-field
                    :error-messages="messages.hours"
                    v-model="course.hours"
                    label="Hours"
                    type="number"
                    class="pr-2"
                    filled
                  ></v-text-field>-->
                  <v-text-field
                    :error-messages="messages.minutes"
                    v-model="course.minutes"
                    label="Duration (mins)"
                    type="number"
                    class=" duration"
                    filled
                    :min="0"
                    @keypress="NumbersOnly"
                  >
                    <template slot="append-outer">
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">fa fa-question</v-icon>
                        </template>
                        <span>Enter the number of minutes this course would take to complete.</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="mt-5">
                 <v-flex xs12>
                  <CategorySelect :cat="this.category"/>
                </v-flex>
              </v-layout>
              <v-combobox
                v-model="course.topics"
                :search-input.sync="search"
                multiple
                label="Keywords"
                append-icon
                chips
                deletable-chips
                item-text="tag"
                item-value="id"
                class="mt-5"
                filled
              >
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span
                      >Enter keywords that reflect the course and its content, this makes it easier for users to find in the Full Course Library.</span
                    >
                  </v-tooltip>
                </template>
              </v-combobox>
              <v-select
                v-model="course.channels"
                :items="channels"
                item-text="name"
                item-value="id"
                label="Playlists"
                multiple
                chips
                hint="Assign course to channels"
                persistent-hint
                filled
                attach
              >
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span>Assign the course to a single playlist, or to multiple playlists.</span>
                  </v-tooltip>
                </template>
              </v-select>
              <drop-zone
                :type="type"
                :accepted="accepted"
                :image.sync="thumbnail"
                class="mt-5 dropzone-container"
                filled
                :dropzone-id="'course_thumbnail'"
              ></drop-zone>
              <label
                v-if="messages.s3_url"
                :error-messages="messages.s3_url"
                class="v-messages theme--light error--text"
                >The course image field is required.
              </label>
              <!-- <template>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="dropzone-help"
                      >fa fa-question</v-icon
                    >
                  </template>
                  <span>Click here to upload Course Image</span>
                </v-tooltip>
              </template> -->
              <p class="block text-left mt-4 caption">
                Max upload filesize: 10MB <br />
                Accepted file formats: png, jpg
              </p>
              <v-text-field
                    :error-messages="messages.archive_after"
                    v-model="course.archive_after"
                    label="Archive After (months)"
                    type="number"
                    class="mt-5 mb-5 duration"
                    filled
                    :min="1"
                    :max="24"
                    @keypress="NumbersOnly"
                    @blur="handleArchiveAfterBlur()" 
                  >
                    <template slot="append-outer">
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">fa fa-question</v-icon>
                        </template>
                        <span>Enter the number of months after which you want the course to be archived automatically</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68" class="mt-2">
      <v-flex px-4 py-4 text-right>
        <v-btn
          v-if="!s3Uploading || !loading"
          color="grey300"
          class="cancel-button"
          @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="s3Uploading || loading" color="primary" loading></v-btn>
        <v-btn
          v-else
          color="dark-blue"
          class="ml-4 add-course-button"
          @click="updateCourse"
          >Save Changes</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import channelAPI from '@/api/channel.js';
import DropZone from '@/components/global/Dropzone';
import EditNotificationMsg from '@/components/admin/notification/EditNotificationMsg';
import notificationAPI from '@/api/notification.js';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CategorySelect from './CategorySelect.vue';
export default {
  name: 'EditCourse',
  components: {
    ClassicEditor,
    DropZone,
    CategorySelect
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: '',
    },
    courseManager: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editorConfig: {
        toolbar: {
          items: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'link',
          ],
        },
      },
      editor: ClassicEditor,
      type: 'thumbnail',
      accepted: 'image/jpg,image/jpeg,image/png',
      search: '',
      messages: {},
      course: {},
      channels: [],
      valid: true,
      loading: false,
      successMessage: 'Course Successfully Updated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      waitMessage: 'Please wait, we are uploading your image.',
      courseTypeOptions: [
        {
          id: 353360,
          name: 'Customer Service',
        },
        {
          id: 353362,
          name: 'First Aid',
        },
        {
          id: 353355,
          name: 'General',
        },
        {
          id: 353359,
          name: 'Health and Safety',
        },
        {
          id: 353356,
          name: 'IT',
        },
        {
          id: 353363,
          name: 'Management',
        },
        {
          id: 353358,
          name: 'Professional',
        },
        {
          id: 353361,
          name: 'Security',
        },
        {
          id: 353357,
          name: 'Technical',
        },
      ],
      is_editable: '',
      notification: {},
      notificationContent: {},
      getBy: '',
      shownUp: '',
      category: null,
    };
  },
  computed: {
    thumbnail() {
      return this.course.hasOwnProperty('thumbnail')
        ? this.course.thumbnail.data
        : null;
    },
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
    selectedChannels() {
      return this.course.channels.data.map((x) => {
        return x.id;
      });
    },
    selectedTopics() {
      return this.course.topics.data.map((x) => {
        return x.tag;
      });
    },
  },
  mounted() {
    this.$store.dispatch('setS3Uploading', false);
    this.getCourse(this.id);
    this.getChannels();
    this.setEventBus();
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    editNotificationMsg(type) {
      this.$showPanel({
        component: EditNotificationMsg,
        props: {
          type: type,
          course_id: this.id,
        },
        openOn: 'right',
      });
    },
    getCourse(id) {
      courseAPI
        .getCourseEditInfo(id, '?include=channels,thumbnail,topics,category')
        .then((response) => {
          this.course = response.data.data;
          if (this.course.hours != 0) {
            this.course.minutes = this.course.hours * 60 + this.course.minutes;
          } else {
            this.course.minutes = this.course.minutes;
          }
          this.course.channels = this.selectedChannels;
          this.course.topics = this.selectedTopics;
          this.$store.dispatch('setDropzoneLoaded', { id: 'course_thumbnail', value: true });
          this.is_editable = this.course.is_default;
          this.category =  this.course.category.data;
        });
    },
    updateCourse() {
      this.course.hours = 0;
      this.loading = true;
      this.course.hours = 0;
      if(this.$refs.form.validate()){
      if (this.$store.getters.s3Url !== null && this.course.thumbnail.data.url !== this.$store.getters.s3Url) {
        this.$snotify.info(this.waitMessage);
      }
      this.course.category_id = this.category ? this.category.id : '';
      courseAPI
        .updateCourse(
          this.id,
          this.course,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails,
        )
        .then((resp) => {
          this.closePanel();
          if (this.courseManager) {
            this.$store.dispatch('setCourse', resp.data.data);
            this.$store.dispatch(
              'setCourseMaterials',
              resp.data.data.assets.data
            );
          }
          EventBus.$emit('COURSES_UPDATED', this.params);
          //EventBus.$emit("COURSE_UPDATED", resp.data.data);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
      }else{
        this.loading = false;
      }
    },
    getChannels() {
      channelAPI.getChannels('?getall=true').then((response) => {
        this.channels = response.data.data;
      });
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleBlur(fieldName){
      const value = parseInt(this.notification[fieldName], 10);
      if (value > 30) {
        this.notification[fieldName] = 30;
      }
    },
    handleArchiveAfterBlur(){
      const value = parseInt(this.course.archive_after, 10);
      if(value == 0){
        this.course.archive_after = 1;
      }
      if (value > 24) {
        this.course.archive_after = 24;
      }
    },
    setEventBus() {
      EventBus.$on("SELCTED_CATEGORY", selectedCategory => {
        this.category = selectedCategory;
      });
      EventBus.$on("FILE_UPLOADED",() => {
        this.$delete(this.messages, "s3_url");
      })
    },
    customMessageRule(value, enabled) {
      if ( enabled && (this.shownUp == 1 || this.shownUp == 3)) {
        return !!(value && value.trim()) || 'Custom notification required.'
      }
      return true
    },
    toggleFieldValidation(field) {
    const switchItem = this.notification[field];
    if (!switchItem) {
      this.$nextTick(() => {
        this.$refs[field].resetValidation();
      });
    }
  }
  },
};
</script>
<style scoped>
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 8px !important;
}

.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit {
  position: relative;
}
.dropzone-container{
  margin-right: 0 !important;
}
</style>
